@if (segmented()) {
    <pf-connected-chips
        [chips]="locationChips() | async | safeArray"
        [pfStatus]="chipStatus()"
        (lastChipClick)="copyLocationBarcode()"></pf-connected-chips>
} @else {
    <!-- Table view: line 1 = zone path (Aisle/Bay/Level bold, BU/Zone muted),
         line 2 = "Slot N". Wraps instead of clipping. -->
    @if (emphasizedLocation() | async; as loc) {
        <span class="cpw-location-text" (click)="copyLocationBarcode()">
            @for (seg of loc.path; track $index; let first = $first) {
                @if (!first) {
                    <span class="cpw-location-text__sep">›</span>
                }
                <span
                    [class.cpw-location-text__strong]="seg.strong"
                    [class.cpw-location-text__muted]="!seg.strong"
                    >{{ seg.label }}</span
                >
            }
        </span>
        @if (loc.second) {
            <span class="cpw-location-text__secondary">{{ loc.second }}</span>
        }
    }
}
